require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-o-wxrr.json") })
        }
      }, "path---photos-professional-o-wxrr");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-o-wxrr!./.cache/json/photos-professional-o-wxrr.json
// module id = 859
// module chunks = 231608221292675